import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useToast } from "@/hooks/use-toast";
import { ChevronLeft } from "lucide-react";
import { DEFAULT_EMAIL_TEMPLATE } from "@/types/notifications";
import { emailNotificationApi } from "@/api/emailNotificationApi";
import EmailEditor from "./EmailEditor";

const EmailTemplateCreate = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  
  // Récupérer le token d'accès depuis le localStorage
  const getAccessToken = () => localStorage.getItem('accessToken');
  
  const [currentTemplate, setCurrentTemplate] = useState({
    ...DEFAULT_EMAIL_TEMPLATE,
    id: `temp_${Date.now()}`
  });
  const [loading, setLoading] = useState(false);

  const handleSaveTemplate = async (updatedTemplate) => {
    setLoading(true);
    try {
      // Créer un nouveau template
      const { id, ...templateData } = updatedTemplate;
      const response = await emailNotificationApi.createTemplate(templateData, getAccessToken());
      
      if (response.status === 201) {
        toast({
          title: "Succès",
          description: "Template créé avec succès"
        });
        // Naviguer vers la liste
        navigate('/dashboard/email-notifications');
      } else {
        toast({
          title: "Erreur",
          description: "Erreur lors de la création du template",
          variant: "destructive"
        });
      }
    } catch (error) {
      toast({
        title: "Erreur",
        description: "Erreur lors de la sauvegarde du template",
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePreview = (template) => {
    // Pour la création, on peut naviguer vers une prévisualisation temporaire
    // ou simplement afficher un message
    toast({
      title: "Prévisualisation",
      description: "Fonctionnalité de prévisualisation en cours de développement"
    });
  };

  const handleGoBack = () => {
    navigate('/dashboard/email-notifications');
  };

  return (
    <div className="container py-8">
      <div className="flex items-center mb-6">
        <Button
          variant="outline"
          onClick={handleGoBack}
          className="mr-4 rounded-xl font-semibold border-slate-200 text-slate-600 hover:bg-slate-50"
        >
          <ChevronLeft className="mr-2 h-4 w-4" /> Retour
        </Button>
        <div>
          <h2 className="text-2xl font-black text-slate-900 tracking-tight">Créer un nouveau modèle</h2>
          <p className="text-sm font-medium text-slate-500 mt-0.5">Créez un nouveau modèle de notification par email</p>
        </div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-slate-500 font-medium">Sauvegarde en cours...</p>
          </div>
        </div>
      ) : (
        <EmailEditor 
          template={currentTemplate}
          onSave={handleSaveTemplate}
          onPreview={handlePreview}
          hideHeader={true}
        />
      )}
    </div>
  );
};

export default EmailTemplateCreate; 